import styled from 'styled-components';

export const Grid = styled.div((p) => ({
  display: 'grid',
  gridTemplateColumns: p.template || 'repeat(12, 1fr)',
  gridColumnGap: p.columnGap || '1.5em',
  gridRowGap: p.rowGap || '1.5em',
}));

export const GridColumn = styled.div((p) => ({
  ...(p.span && { gridColumn: 'span ' + p.span }),
}));
